import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { cleanRut, formatRut } from 'rutlib/lib';
import { AlertHelper } from 'src/app/shared/components/helpers/alert.helpers';
import { EntregaEquipoLinkService } from 'src/app/pages/services/entrega-equipo-link.service';
import { TrabajadoresService } from 'src/app/pages/services/trabajadores/trabajadores.service';

// Reconciliación manual de un movimiento "sin vincular" (equipo entregado antes de que el
// trabajador existiera en el sistema): busca por rut al trabajador ya cargado y le asigna
// el fk_trabajador a ESTE movimiento puntual, reusando el mismo endpoint de editar movimiento
// (ya valida que sea una fila de bitácora y no una legacy).
@Component({
  selector: 'app-vincular-trabajador-dialog',
  templateUrl: './vincular-trabajador-dialog.component.html'
})
export class VincularTrabajadorDialogComponent {

  rutBusqueda: string = '';
  trabajadoresCache: any[] = [];
  sugerencias: any[] = [];

  trabajadorSeleccionado: { id: number; nombres: string; apellidos: string; rut: any } | null = null;
  buscando: boolean = false;
  buscado: boolean = false;
  vinculando: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<VincularTrabajadorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private alert: AlertHelper,
    private entregaEquipoLinkService: EntregaEquipoLinkService,
    private trabajadoresService: TrabajadoresService
  ) {
    this.trabajadoresService.TraerTrabajadores().subscribe(res => {
      if (res.success) {
        this.trabajadoresCache = res.data || [];
      }
    });
  }

  onRutInput(event: Event) {
    const valor = (event.target as HTMLInputElement).value;
    this.rutBusqueda = formatRut(valor);
    this.trabajadorSeleccionado = null;
    this.buscado = false;

    const textoLimpio = cleanRut(valor);
    if (!textoLimpio || textoLimpio.length < 3) {
      this.sugerencias = [];
      return;
    }
    this.sugerencias = this.trabajadoresCache
      .filter((t: any) => t.rut && t.rut.toString().includes(textoLimpio))
      .slice(0, 8);
  }

  seleccionarTrabajador(trabajador: any) {
    this.rutBusqueda = formatRut(trabajador.rut.toString());
    this.sugerencias = [];
    this.trabajadorSeleccionado = { id: trabajador.id, nombres: trabajador.nombres, apellidos: trabajador.apellidos, rut: trabajador.rut };
    this.buscado = true;
  }

  buscarPorRut() {
    if (!this.rutBusqueda || this.rutBusqueda.trim().length === 0) {
      return;
    }
    const rutLimpio = cleanRut(this.rutBusqueda);
    this.buscando = true;
    this.trabajadorSeleccionado = null;
    this.buscado = false;
    this.trabajadoresService.traerTrabajadoRut(rutLimpio).subscribe({
      next: (respuesta) => {
        this.buscando = false;
        this.buscado = true;
        if (respuesta?.success && Array.isArray(respuesta.data) && respuesta.data.length > 0) {
          const t = respuesta.data[respuesta.data.length - 1];
          this.trabajadorSeleccionado = { id: t.id, nombres: t.nombres, apellidos: t.apellidos, rut: t.rut };
        }
      },
      error: () => {
        this.buscando = false;
        this.buscado = true;
      }
    });
  }

  vincular() {
    if (!this.trabajadorSeleccionado) {
      return;
    }
    this.vinculando = true;
    this.entregaEquipoLinkService.editarMovimiento(this.data.movimiento.id, { fk_trabajador: this.trabajadorSeleccionado.id }).subscribe({
      next: (res) => {
        this.vinculando = false;
        if (res.success) {
          this.alert.success_small('Trabajador vinculado correctamente');
          this.dialogRef.close(true);
        } else {
          this.alert.error_small(res.msg || 'No se pudo vincular');
        }
      },
      error: () => { this.vinculando = false; }
    });
  }

  cancelar() {
    this.dialogRef.close(false);
  }

}
